import { Form, Input, Row, Col, Select, Switch, InputNumber, Button, Space, Tooltip, Modal } from 'antd';
import { useRef, useState, useEffect } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal'
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx'
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../universal/getList';
import systemConfig from '../../../config/systematic';
// import { SearchOutlined } from '@ant-design/icons';
import antMessage from '../../../utils/extend/AntdNotification';
import arrayString from '../../../utilsTs/baseLib/arrayString';


//布局
const layout = {
    // labelCol: { span: 8 },
    // wrapperCol: { span: 16 }, 
};

const ClientUserEdit = (props: any) => {
    const [form] = Form.useForm(); //form  
    const { data } = props;
    const ref = useRef<any>(undefined);

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;
    const [userData, setUserData] = useState<any>();
    const [modalMembership, setModalMembership] = useState<boolean>(false);
    const [membershipData, setMembershipData] = useState<any>();
    const handleModalMembership = () => {
        setModalMembership(false);
    };

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    /** 后端数据defaultService */

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }
        const fetchData = async () => {
            fetchApi.GET(wmService,
                {
                    apiId: 'user',
                    apiExtend: 'showListEx'
                }).then(res => {
                    setUserData(res.data);
                });
        };
        fetchData();
    }, []);

    const getMembershipInfo = () => {
        const apiVariable = form.getFieldValue('unionId');
        fetchApi.GET(wmService,
            {
                apiId: 'membership',
                apiExtend: 'getInfo',
                apiVariable
            }).then(res => {
                if (res.success === true) {
                    let arr: Array<string> = [];
                    for (let i = 0; i < res.data.length; i++) {
                        arr = arrayString.addItemUnique(arr, res.data[i].id);
                    }
                    setMembershipData(JSON.stringify(res.data, null, 2));
                    setModalMembership(true);
                    form.setFieldValue('membershipId', arrayString.arrayToString(arr));
                } else {
                    antMessage('error', '无会员信息！');
                }
            });
    };


    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'clientUser',
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '客户'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}>

                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>

                    <Row gutter={[8, 0]}>
                        <Col span={8}>
                            <Form.Item
                                label="unionId"
                                name="unionId">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="昵称"
                                name="nickName">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="手机号码"
                                name="mobile">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="同时在线"
                                tooltip='对当前用户登录数进行限制，超过登录数，会踢掉最先登录'
                                name="sameTimeOnlines">
                                <InputNumber style={{ width: 60 }} />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="关联用户"
                                name="userId">

                                <Select
                                    showSearch
                                    placeholder="选择用户"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(userData, 'userName', 'id', undefined, true)}
                                </Select>
                            </Form.Item>
                        </Col>

                        {/* <Col span={10}>
                            <Form.Item
                                label="会员id"
                                name="membershipId"
                                tooltip='bms的会员id'
                            >
                                <Space.Compact>
                                    <Input
                                        value={Form.useWatch('membershipId', form)}
                                        onChange={(e) => form.setFieldsValue({ membershipId: e.target.value })}
                                    />
                                    <Tooltip title="查询资料">
                                        <Button type="primary" shape="circle" icon={<SearchOutlined />}
                                            onClick={() => getMembershipInfo()} />
                                    </Tooltip>
                                </Space.Compact>
                            </Form.Item>
                        </Col> */}

                        <Col span={5}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>

            </AntDraggableModal>
            {modalMembership === true ?
                <Modal
                    title="会员信息"
                    open={modalMembership}
                    onOk={handleModalMembership}
                    onCancel={handleModalMembership}
                    cancelButtonProps={{ style: { display: "none" } }}
                >
                    <p>{membershipData}</p>
                </Modal>
                : null}
        </>
    )
}

export default ClientUserEdit;